import { createSlice } from '@reduxjs/toolkit';

import { experiencesApiUrlCreator } from '@lib/core/experiences/slices/urls';
import { TExperience } from '@lib/core/experiences/types';
import { TProductCategory } from '@lib/core/products/types';
import { ApiQueries } from '@lib/core/service/consts';
import { createTypedAsyncThunk } from '@lib/core/service/createTypedAsyncThunk';
import { request } from '@lib/core/service/requests/request';

type TPayloadArgs = {
  productCategory: TProductCategory;
  producerId?: string;
};

interface IState {
  error: string;
  data: TExperience[];
  isLoading: boolean;
}

const initialState: IState = {
  data: [],
  error: '',
  isLoading: false,
};

export const actionGetExperiences = createTypedAsyncThunk<TExperience[], TPayloadArgs>(
  'actionGetExperiences',
  async ({ productCategory, producerId = '' }) => {
    const params = {
      ...(productCategory && { [ApiQueries.productCategoryName]: productCategory }),
      ...(producerId && { [ApiQueries.producerIdentifier]: producerId }),
    };

    const { results = [] } = await request({ params, url: experiencesApiUrlCreator() });
    return results;
  },
);

export const experiencesSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionGetExperiences.pending, state => {
      state.data = [];
      state.error = '';
      state.isLoading = true;
    });
    builder.addCase(actionGetExperiences.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.isLoading = false;
    });
    builder.addCase(actionGetExperiences.rejected, (state, action) => {
      state.error = action.error.message;
      state.isLoading = false;
    });
  },
  initialState,
  name: 'experiences',
  reducers: {},
});

export default experiencesSlice.reducer;
